
import Template from 'components/templates/SubSections.vue'
import SubSections from 'components/mixins/SubSections.vue'


/* Blocks for version 2 of site*/
import FlexBlock from 'components/globalBlocks/FlexBlock.vue'
import FlexButtons from 'components/globalBlocks/FlexButtons.vue'

import ImageBlock from 'components/blocks/Image.vue'
import Animation from 'components/blocks/Animation.vue'
import Related from 'components/blocks/Related.vue'
import Circles from 'components/blocks/Circles.vue'
import ArticleBlock from 'components/blocks/Article.vue'
import LogoList from 'components/blocks/LogoList.vue'
import HtmlBlock from 'components/blocks/Html.vue'
import Null from 'components/blocks/Null.vue'


import ArticleLoader from 'components/combinedBlocks/ArticleLoader.vue'
import PressReleases from 'components/combinedBlocks/PressReleases.vue'
import HeaderFull from 'components/combinedBlocks/HeaderFull.vue'
import VideoFull from 'components/combinedBlocks/Video.vue'

import ColumnedExpandablelist from 'components/combinedBlocks/ColumnedExpandablelist.vue'

import {mapMutations, mapGetters} from 'vuex';

export default {
  block: 'subSections',
  props: ['data'],
  // computed: {
  //   ...mapGetters([
  //     'currentSection'
  //   ]),
  // },
  mixins: [
    Template,
    SubSections
  ],
  // watch: {
  //   // Set current section false when switching section 
  //   // E.g. when checklist is shown and switching section
  //   currentSection: function(){
  //     this.setBackDrop(false);
  //   }
  // },
  components: {
    HeaderFull,
    FlexBlock,
    FlexButtons,
    VideoFull,
    ImageBlock,
    Animation,
    Related,
    Circles,
    ArticleBlock,
    PressReleases,
    ArticleLoader,
    LogoList,
    HtmlBlock,
    Null,
    ColumnedExpandablelist
  },
  methods: {
    getBlockModifiers() {
      let bms = this.block;

      if (!this.data)
        return bms;

      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      if (this.data.color) {
        bms += ' bm-'+this.data.color;
      }

      return bms;
    },
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/SubSections.vue